import { render, staticRenderFns } from "./PaginaReportesResultados.vue?vue&type=template&id=1904a0b2"
import script from "./PaginaReportesResultados.vue?vue&type=script&lang=js"
export * from "./PaginaReportesResultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports